import { useEffect } from "react";
import { differenceInMinutes } from "date-fns";
import { Link } from "react-router-dom";
import { jt, t } from "ttag";
import { useCountdown } from "usehooks-ts";

import { ROUTES } from "@/app/router";
import { usePortalUserStore } from "@/app/stores";
import { Button, Countdown, NotificationBar } from "@/shared/ui";

const BLACK_FRIDAY_DISCOUNT = 400 as const;

export const BlackFridayBanner = () => {
  const blackFridayEndsAt = usePortalUserStore(
    (state) => state.portalUser?.blackFriday?.endsAt,
  );

  const countStart = blackFridayEndsAt
    ? differenceInMinutes(new Date(blackFridayEndsAt), new Date())
    : 0;

  const [minutesLeft, { startCountdown }] = useCountdown({
    countStart,
    intervalMs: 60_000,
  });

  useEffect(() => {
    startCountdown();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const discountStrong = (
    <strong key="discount-strong">{t`up to $${BLACK_FRIDAY_DISCOUNT}`} </strong>
  );

  const blackFridayStrong = (
    <strong key="black-friday-strong">Black Friday!</strong>
  );

  if (minutesLeft === 0) {
    return null;
  }

  return (
    <NotificationBar
      color="success"
      className="flex-col items-center gap-2 sm:flex-row sm:gap-6"
    >
      <p>{jt`Save ${discountStrong} on ${blackFridayStrong}`}</p>

      <div className="flex gap-6">
        <Countdown minutesLeft={minutesLeft} />

        <Button size="sm" asChild>
          <Link to={ROUTES.SHOP.OVERVIEW}>{t`Shop now`}</Link>
        </Button>
      </div>
    </NotificationBar>
  );
};
